import useEventCallback from '@unifyapps/hooks/useEventCallback';
import { useCleverTap } from '../../../../../auth/hooks/cleverTap/useCleverTap';
import type { OnActionType } from '../../../../context/ActionsProvider/context';
import { useGetNoCodeComputedData } from '../../../computeContext/useGetNoCodeComputedData';
import { SHOULD_NOT_PROPAGATE_UP } from '../../const';
import { CleverTapControlAction } from './schema/controlCleverTap';

function useControlCleverTap() {
  const { recordEvent } = useCleverTap();
  const { getNoCodeComputedData } = useGetNoCodeComputedData();

  const onControlCleverTap: OnActionType = useEventCallback((args) => {
    const { action, actionContext } = args;
    const operation = action.payload?.operation;

    switch (operation) {
      case CleverTapControlAction.RecordEvent: {
        const eventName = action.payload?.eventName as string | undefined;
        const eventProperties = action.payload?.eventProperties as
          | { key: string; value: string }[]
          | undefined;

        if (!eventName) {
          return Promise.resolve(SHOULD_NOT_PROPAGATE_UP);
        }

        // resolve data pills in event name
        const { value: computedEventName } = getNoCodeComputedData<{ value: string }>(
          { value: eventName },
          actionContext,
        );

        // resolve data pills in each property key and value
        const properties: Record<string, string> = {};

        if (Array.isArray(eventProperties)) {
          for (const prop of eventProperties) {
            if (!prop.key || !prop.value) {
              continue;
            }

            const { value: computedKey } = getNoCodeComputedData<{ value: string }>(
              { value: prop.key },
              actionContext,
            );
            const { value: computedValue } = getNoCodeComputedData<{ value: string }>(
              { value: prop.value },
              actionContext,
            );

            if (computedKey && computedValue !== null && computedValue !== undefined) {
              properties[computedKey] = String(computedValue);
            }
          }
        }

        recordEvent({ event: computedEventName, properties });
        return Promise.resolve(SHOULD_NOT_PROPAGATE_UP);
      }
      default:
        return Promise.resolve(SHOULD_NOT_PROPAGATE_UP);
    }
  });

  return { onControlCleverTap };
}

export default useControlCleverTap;
